import { generateAVGLineChart } from "../vis/ChartGenerator";
import { Popup } from "mapbox-gl";
import { generateCombinationChart } from "../vis/ChartGenerator";

export default class MapInfoWindow {
  #chart: any;
  #id;

  constructor(
    id: string,
    map: any,
    lnglat: [number, number],
    title: string,
    data: any,
    closeCallback: Function
  ) {
    console.log(lnglat, title, data, close);
    this.#id = id;
    this.#init(id, map, lnglat, title, data, closeCallback);
    return this;
  }

  #init(
    id: string,
    map: any,
    lnglat: any,
    title: any,
    aggregatedData: any,
    closeCallback: Function
  ) {
    const that = this;
    const popupContent = document.createElement("div");
    popupContent.innerHTML = `<div class="infoHeading infoHeading${id}">${title}</div><hr><div class="infoContent infoContent${
      that.#id
    }"><div class="popupStats">Statistik zu ausgewählten Datenpunkten</div><div class="popupCharts"></div></div>`;

    const popup: Popup = new Popup({
      closeOnClick: false,
      className: "mapPopup",
      maxWidth: "auto",
      closeButton: true,
    })
      .setLngLat(lnglat)
      .setDOMContent(popupContent)
      .addTo(map)
      .on("close", (_) => {
        closeCallback(id);
      });
    console.log(lnglat);

    const infoContent: any = $(popupContent).find(".infoContent");
    const popupChartsContainer = infoContent.find(".popupCharts").get(0);
    const tempsettings = $("#indicatorsettingsghost").data("settings");
    const tempMetaSettings = $("#indicatorMetaGhost").data("indicatorMeta");
    let chartdisplayname;

    // Function to calculate the sum of indicators for year 2020
    function sumIndicatorsForYear2020(data: any) {
      return data.reduce((sum: any, arr: any) => {
        arr.forEach((obj: any) => {
          if (obj.year === 2020) {
            sum += obj.indicator;
          }
        });
        return sum;
      }, 0);
    }

    // fill aggregatedData with data from the selected polygons
    aggregatedData.sumForYear2020 = sumIndicatorsForYear2020(
      aggregatedData.dataOutsidePolygon
    );
    console.log(aggregatedData);

    // Find the displayname of the indicator
    chartdisplayname = tempMetaSettings.find(
      (x: any) => x.id === tempsettings.indicator.id
    ).displayname;

    // Generate the charts based on the rendering type
    if (
      tempsettings.indicator.parameters.p_rendering === "abs" ||
      tempsettings.indicator.parameters.p_rendering === undefined
    ) {
      const combinationChart = generateCombinationChart(
        popupChartsContainer,
        aggregatedData,
        chartdisplayname
      );
    } else if (tempsettings.indicator.parameters.p_rendering === "rel") {
      const avgLineChart = generateAVGLineChart(
        popupChartsContainer,
        aggregatedData.averageIndicatorsByYear,
        chartdisplayname
      );
    }

    const chartsHeight = $(popupChartsContainer as any).height();
    const popupHeight = Math.max((chartsHeight as any) + 25);

    $(".highcharts-credits").text("Quelle: Bundesamt für Statistik (BFS)");
    $(".highcharts-credits").on("click", function () {
      window.open("https://www.bfs.admin.ch/bfs/de/home.html");
    });

    // Handle click event on the heading to toggle the content
    $(popupContent)
      .find(`.infoHeading${id}`)
      .on("click", (_) => {
        if (infoContent && infoContent.height() <= 0) {
          infoContent.animate({ width: 600, height: popupHeight }, 1400);
          // optimal: widht: 600,  height: 410
        } else {
          infoContent.animate({ width: 0, height: 0 }, 500);
        }
      });
  }
}
